import currency from "currency.js";

export function formatCurrency(amount) {
  return currency(amount, { precision: 2 }).format();
}
